import { escapeRegExp } from '@mui/x-data-grid/internals';
import { EvacZone } from 'shared/types';
import { getValidRegExp, removeHTMLTags } from 'shared/utils';

export const hasEvacInfoChanged = (
  prev: string | null,
  next: string,
): boolean => {
  const prevValue = (prev || '').trim();
  const nextValue = next.trim();
  if (prevValue !== '') return prevValue !== nextValue;

  // If the previous value was empty, we need to check against a tagless version of the new value. In
  // the rich text editor, if you type something and then remove it, the value will not be empty, it'll
  // be empty content enclosed in HTML tags (which will later be ignored on submission).
  const taglessNextValue = removeHTMLTags(nextValue);
  return prevValue !== taglessNextValue;
};

export const checkEvacFieldChanged = (
  prevHasCustom: boolean,
  currentHasCustom: boolean,
  prevValue: string | null,
  newValue: string,
): boolean => {
  return (
    prevHasCustom !== currentHasCustom ||
    (currentHasCustom && hasEvacInfoChanged(prevValue, newValue))
  );
};

export const findZoneNamesInMessage = (
  evacZones: EvacZone[],
  message: string,
): string[] => {
  const found: string[] = [];
  evacZones.forEach((zone) => {
    // Escape any special regex characters in the zone name (e.g. parens)
    const escapedName = escapeRegExp(zone.displayName);
    // Use lookahead/lookbehind to ensure the zone name is not part of a larger word
    // Not using \b because the zone name might contain non word chars (e.g. parens)
    // Match if preceded by start of string, whitespace, or punctuation
    // and followed by end of string, whitespace, or punctuation
    const pattern = `(?<=^|\\s|[,;:.!?\\-])(${escapedName})(?=\\s|[,;:.!?\\-]|$)`;

    if (getValidRegExp(pattern)?.test(message)) {
      found.push(zone.displayName);
    }
  });
  return found;
};
